/*
 * Filename: d:\projects\AutoFiFront\src\Theme\SelectStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 3:23:37 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import styled from "styled-components";

const SelectStyled = styled.select.attrs(props => ({
    bgColor: props.bgColor,
    borderWidth: props.borderWidth
}))`
@keyframes apparition {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  10% {
    opacity: 0.1;
    transform: translateY(-25px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
appearance: none;
border-radius: 5px;
height: 3rem;
background-color: #fff;
padding: 0 0.5rem;
position: relative;
animation: apparition 0.5s ease-in-out;
border: solid ${props => props.borderWidth} ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
`;

export default SelectStyled;
